import { Link, useParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

export default function UnlockPlaceholder() {
  const { playerId } = useParams();
  return (
    <div className="max-w-2xl mx-auto px-6 py-24">
      <div className="border border-white/8 p-10 bg-[#151B28]/60 relative overflow-hidden" data-testid="unlock-placeholder">
        <div className="absolute inset-x-0 top-0 h-[2px] bg-[#2DD4A7]" />
        <Lock className="w-10 h-10 text-[#F5B841] mb-6" />
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Unlock contact</div>
        <h1 className="font-display text-4xl font-black tracking-tighter mb-4">Pay to unlock</h1>
        <p className="text-sm text-[#8B97AE] leading-relaxed mb-4">Payments for unlocking a verified player's contact will be enabled in the next release. Once paid, the player alias becomes visible and a chat channel opens between you and the player. Aliases, wallet addresses and any contact info stay masked in the marketplace until this payment completes.</p>
        <div className="text-[11px] font-mono text-[#8B97AE] mb-8">Player reference: <span className="text-[#E8ECF4]" data-testid="unlock-player-id">{playerId}</span></div>
        <div className="flex flex-wrap gap-3">
          <Button asChild className="rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-11 px-5 font-semibold transition-colors">
            <Link to="/marketplace" data-testid="unlock-back">Back to marketplace</Link>
          </Button>
          <Button asChild variant="ghost" className="rounded-none border border-white/15 h-11 px-5 font-semibold text-[#E8ECF4] hover:bg-white/10 transition-colors">
            <Link to="/streamer">Streamer dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
